//import { useSessionStore } from '@/stores/session';
import ky from 'ky';

export const experienceApiClient = ky.create({
  prefixUrl: import.meta.env.VITE_EXPERIENCE_API_URL,
  timeout: 8000, // 8 seconds
  headers: {
    'Content-Type': 'application/json',
  },
  hooks: {
    beforeRequest: [
      () => {
        /* const accessToken =
          useSessionStore.getState().authStore.loginCredentials.access_token;
        if (accessToken) {
          request.headers.set('Authorization', `Bearer ${accessToken}`);
        } */
      },
    ],
    beforeError: [
      async (error) => {
        // Extract the error message from the response. It works fine,
        // but if it's not consistent, we need to change the way we handle errors
        const { response } = error;
        return response.json();
      },
    ],
  },
});

export const sqExperienceApiClient = experienceApiClient.extend({
  prefixUrl: import.meta.env.VITE_SQ_EXPERIENCE_API_URL,
});

export const cmsApiClient = ky.create({
  prefixUrl: import.meta.env.VITE_CMS_API_URL,
  timeout: 4000, // 4 seconds
  headers: {
    'Content-Type': 'application/json',
  },
});

export const chatBotExperienceApiClient = experienceApiClient.extend({
  prefixUrl: import.meta.env.VITE_CHATBOT_EXPERIENCE_API_URL,
});
